import { Box, Skeleton, useTheme } from '@mui/material';
import { SiVisa, SiMastercard } from 'react-icons/si';
import { FaCcAmex, FaCcDinersClub, FaCcDiscover, FaCcJcb, FaCreditCard } from 'react-icons/fa';

/* ----------  brand → icon map  ---------- */
const ICON_MAP: Record<string, React.ElementType> = {
  visa: SiVisa,
  mastercard: SiMastercard,
  amex: FaCcAmex,
  american_express: FaCcAmex,
  diners: FaCcDinersClub,
  discover: FaCcDiscover,
  jcb: FaCcJcb,
};

/* ----------  main component  ---------- */
export const CardIcon: React.FC<{ brand?: string; loading: boolean }> = ({ brand, loading }) => {
  const theme = useTheme();

  if (loading) return <Skeleton variant="circular" width={40} height={40} />;

  const normalised = (brand || '').toLowerCase();
  const Icon = ICON_MAP[normalised] ?? FaCreditCard; // fallback generic card

  return (
    <Box
      sx={{
        width: 48,
        height: 48,
        borderRadius: 2,
        backgroundColor: 'rgba(126, 34, 206, 0.08)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.text.secondary,
        fontSize: 24, // size of the react-icon
      }}
    >
      <Icon />
    </Box>
  );
};
